import React from 'react';
import { Navbar, Nav, Container, Button, Spinner } from 'react-bootstrap';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const protectedLinks = [
  ['/users/dashboard', 'Dashboard']
];

const CustomNavbar = () => {
  const { user, isAuthenticated, logout, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const profile = user?.data || user || {};
  const displayName = profile.emp_name || profile.name || profile.email || 'User';
  const isLoginPage = location.pathname === '/users/login';

  const handleLogout = () => {
    logout();
    navigate('/users/login', { replace: true });
  };

  if (loading) {
    return (
      <Navbar bg="dark" variant="dark" className="navbar-custom mb-4">
        <Container className="justify-content-center">
          <Spinner animation="border" variant="success" size="sm" aria-label="Loading session" />
        </Container>
      </Navbar>
    );
  }

  return (
    <Navbar bg="dark" variant="dark" expand="lg" className="navbar-custom mb-4">
      <Container fluid>
        <Navbar.Brand as={Link} to={isAuthenticated ? '/users/dashboard' : '/'}>
          <span className="me-2" aria-hidden="true">🔐</span>
          WBUOA Admin
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="admin-navbar" />

        <Navbar.Collapse id="admin-navbar">
          <Nav className="me-auto">
            {isAuthenticated ? (
              protectedLinks.map(([path, label]) => (
                <Nav.Link
                  key={path}
                  as={Link}
                  to={path}
                  active={location.pathname.startsWith(path)}
                >
                  {label}
                </Nav.Link>
              ))
            ) : (
              <Nav.Link as={Link} to="/" active={location.pathname === '/'}>Home</Nav.Link>
            )}

          </Nav>

          <Nav className="align-items-lg-center">
            {isAuthenticated ? (
              <>
                <Nav.Link
                  as={Link}
                  to="/users/update-password"
                  active={location.pathname === '/users/update-password'}
                  className="profile-link"
                >
                  <strong>{displayName}</strong>
                  {profile.email && <small className="d-block">{profile.email}</small>}
                </Nav.Link>
                <Button
                  variant="outline-light"
                  onClick={handleLogout}
                  className="logout-btn ms-lg-2"
                >
                  Logout
                </Button>
              </>
            ) : (
              <>
                <Nav.Link as={Link} to="/users/login" active={location.pathname === '/users/login'}>
                  Login
                </Nav.Link>
                {!isLoginPage && (
                  <Nav.Link as={Link} to="/users/register" active={location.pathname === '/users/register'}>
                    Register
                  </Nav.Link>
                )}
              </>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default CustomNavbar;
